module.exports = __webpack_public_path__ + "img/qrcode_img.d55e0fe7.png";